import type { IconSvgObject } from './types';

const ChevronsDownUpIcon: IconSvgObject = [
  ["path", { d: "M7 19C7 19 10.6824 14 12 14C13.3176 14 17 19 17 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 5.00004C7 5.00004 10.6824 9.99999 12 10C13.3176 10 17 5 17 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsDownUpIcon;
